if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('.prime-sticky-atc__button');
        this.priceContainer = this.querySelector('.prime-sticky-atc__price');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);

        this.updateUtilityDockOffset = (isVisible) => {
          if (isVisible) {
            document.documentElement.style.setProperty('--prime-sticky-atc-height', `${this.offsetHeight}px`);
          } else {
            document.documentElement.style.removeProperty('--prime-sticky-atc-height');
          }
        };

        if (!this.mainButton || !('IntersectionObserver' in window)) return;

        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.classList.toggle('prime-sticky-atc--visible', scrolledPast);
          this.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
          this.updateUtilityDockOffset(scrolledPast);
        });
        this.intersectionObserver.observe(this.mainButton);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.classList.contains('prime-sticky-atc--visible')) this.updateUtilityDockOffset(true);
          });
          this.resizeObserver.observe(this);
        }

        // Mirror variant/inventory changes made to the main buy box.
        this.mutationObserver = new MutationObserver(() => this.sync());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        if (this.mainPrice) {
          this.mutationObserver.observe(this.mainPrice, { childList: true, subtree: true });
        }
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.updateUtilityDockOffset?.(false);
      }

      sync() {
        if (this.button) {
          this.button.toggleAttribute('disabled', this.mainButton.hasAttribute('disabled'));

          const label = this.mainButton.querySelector('span')?.textContent.trim();
          const target = this.button.querySelector('span');
          if (label && target && target.textContent !== label) target.textContent = label;
        }

        const price = this.mainPrice?.querySelector('.price');
        if (price && this.priceContainer) {
          this.priceContainer.innerHTML = price.outerHTML;
        }
      }
    }
  );
}
